import type { ItineraryItem } from '../types';
import type { MapMarker } from '../components/UnifiedMap';

/**
 * Convert itinerary items to map markers.
 * Only includes items with server-resolved coordinates.
 */
export function itineraryItemsToMarkers(items: ItineraryItem[]): MapMarker[] {
  return items
    .filter(i => i.latitude != null && i.longitude != null)
    .map(i => ({
      id: String(i.id),
      lat: i.latitude!,
      lng: i.longitude!,
      label: i.name,
      sublabel: i.time ? formatTime(i.time) : undefined,
    }));
}

/**
 * Convert community plan day activities to map markers.
 */
export function planActivitiesToMarkers(
  activities: Array<{ name: string; time?: string; lat?: number; lng?: number }>,
  dayNum?: number,
): MapMarker[] {
  return activities
    .filter(a => a.lat != null && a.lng != null)
    .map((a, i) => ({
      id: `${dayNum ?? 0}-${i}`,
      lat: a.lat!,
      lng: a.lng!,
      label: a.name,
      sublabel: a.time,
    }));
}

/**
 * Convert community plan days to trip-overview markers (one per day center).
 */
export function planDaysToMarkers(
  days: Array<{ day: number; label: string; center_lat?: number; center_lng?: number }>,
): MapMarker[] {
  return days
    .filter(d => d.center_lat != null && d.center_lng != null)
    .map(d => ({
      id: `day-${d.day}`,
      lat: d.center_lat!,
      lng: d.center_lng!,
      label: `Day ${d.day}: ${d.label}`,
    }));
}

function formatTime(timeStr: string): string {
  const [hours, minutes] = timeStr.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
}
